export class CodeListRequest{
    codeListId : number;
    
    constructor(codeListId : number)
    {
        this.codeListId = codeListId;
        
    }
}
